package com.vizio.redwolf.pay.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/**
 * Reference: https://github.com/BuddyTV/vizio-models/blob/master/development/sdk/redwolf/IdentityGraph.kt
 */
@Serializable
data class DefaultCreditCardInfo(
    val cardToken: String,
)

/**
 * Reference: https://github.com/BuddyTV/vizio-models/blob/master/development/sdk/redwolf/IdentityGraph.kt
 */
@Serializable
data class NewCreditCardInfo(
    @SerialName("cardNonce") val cardNonce: String,
    @SerialName("isDefault") val isDefault: Boolean = false,
    @SerialName("billingAddress") val billingAddress: BillingAddress
)

@Serializable
data class AddCreditCardClientRequestInfo(
    val cardNonce: String,
    val isDefault: Boolean,
    val billingAddress: BillingAddress,
    val messageToken: String?,
    val reCaptchaToken: String?
)

@Serializable
data class UpdateCreditCardInfo(
    @SerialName("cvv") val cvv: String,
    @SerialName("expirationMonth") val expirationMonth: Int,
    @SerialName("expirationYear") val expirationYear: Int,
    @SerialName("billingAddress") val billingAddress: BillingAddress?,
)
